module.exports = __webpack_public_path__ + "img/two_0.01ea3cf5.png";